<template>
  <div class="cmp-booking-venues-venue_list dt-page">
    <div class="dt-page--top-bar v1">
      <div class="dt-page--add-button">
        <div class="dt-icon-container">
          <img
            @click="onAddVenueClick"
            class="dt-icon"
            src="static/buttons/add.svg"
            alt=""
          />
        </div>
      </div>

      <div class="search">
        <InputField
          :value="basicFilter.searchString"
          :placeholder="$t('search')"
          :config="{
            borderStyle: 'bottom',
            maxWidth: '200px',
            minWidth: '200px',
            width: '200px',
          }"
          @keyup="onSearchInputKeyup"
        ></InputField>
        <!-- <InputField
          :value="searchString"
          :placeholder="'Search'"
          :config="{
            borderStyle: 'bottom',
          }"
          @keyup="onSearchInputKeyup"
        ></InputField> -->
      </div>
    </div>
    <div class="artist-list dt-page--data-table">
      <NTable
        id="booking-venues-venue_list"
        :config="venueTableConfig"
        :headers="headers"
        :items="list"
        class="venue-list h1"
        :loadingFlag="loadingFlag"
        @scrollnext="onListScroll"
      >
        <template v-slot:item="{ item, tdcon }">
          <tr
            :class="{
              selected: selectedRow(item),
            }"
            @click="onRowClicked(item)"
            :title="$t('click_to_see_venue_details')"
          >
            <td v-bind="tdcon('locations')">
              <span>{{ item["booking_location_name"] }}</span>
            </td>
            <td v-bind="tdcon('address1')">
              <span>{{ item["address1"] }}</span>
            </td>
            <td v-bind="tdcon('city')">
              <span>{{ item["city"] }}</span>
            </td>
            <td v-bind="tdcon('country')">
              <span>{{ item["country"] }}</span>
            </td>
            <td v-bind="tdcon('phone1')">
              <span>{{ item["phone1"] }}</span>
            </td>
            <td v-bind="tdcon('capacity')">
              <span>{{ item["venue_capacity"] }}</span>
            </td>
            <td v-bind="tdcon('url1')">
              <span>{{ item["url1"] }}</span>
            </td>
            <td v-bind="tdcon('email')">
              <span>{{ item["email"] }}</span>
            </td>
            <td v-bind="tdcon('options')">
              <div class="option-buttons">
                <div class="mail-button">
                  <img
                    v-if="item['email1']"
                    src="static/icons/email/email-grey.svg"
                    class="dt-icon"
                    @click="(e) => onMail(item)"
                    alt=""
                  />
                </div>
                <div class="delete-button">
                  <img
                    src="static/icons/delete.svg"
                    @click.stop="(e) => deleteVenue(item)"
                    class="dt-icon"
                    alt=""
                  />
                </div>
              </div>
            </td>
          </tr>
        </template>
      </NTable>
    </div>
    <!-- <v-navigation-drawer
        temporary
        :right="right"
        :clipped="clipped"
        :width=1200
        :value="venueDetailsFlag"
        fixed
        stateless
        hide-overlay
        app
      >
      <VenueSidewindow
        @closeVenueSidewindow="onCloseVenueSidewindow"
      ></VenueSidewindow>

      </v-navigation-drawer> -->

    <Sidewindow :navConfig="defaultConfig" :value="venueDetailsFlag" @closed="onCloseVenueSidewindow">
      <VenueSidewindow></VenueSidewindow>
    </Sidewindow>
  </div>
</template>

<script>
import { BookingStoreNamespace as storeNS } from "../store";
import { mapActions, mapGetters, mapMutations } from "vuex";
import * as VenueActionTypes from "../store/venues/types";
import * as ArtistActionTypes from "../store/venues/types";
import InputField from "@plugins/text-field/input-field";
import Dropdown from "@plugins/dropdown/dropdown";
import NTable from "@/plugins/datatable/datatable";

import Sidewindow from "../../../dt-plugins/sidewindow/sidewindow";
import VenueSidewindow from "../components/venue/venue-sidewindow";

import {
  artistDetailsSelectable,
  SelectResults,
  artistDetailsRoute,
  artistListRoute,
  artistDetailsTabRoute,
  bookingVenueRoutes,
  getVenueDetailsSelectable,
} from "../router/router";
import { SET_MAIN_NAV_ACTIVE } from "../../../store/app/types";
import { childOfOrEqual } from "../../../router/functions";
import { decode } from "../../../utility";
import { Subject } from "rxjs";
import { distinctUntilChanged, debounceTime } from "rxjs/operators";
import { ConfirmationService,createConfirmResult } from "../../../dt-plugins/confirmation/confirmation.service";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../plugins/datatable";
import { VenueService } from "../services/venues";
import { createFetchListMixin } from "../../../dt-plugins/advanced-search/fetch-list.mixin";
import { confirmDelete } from "../../../dt-plugins/confirmation/confirmation-common";
import { bookingVenueListLDTRoutes, getBookingVenueDetailsSelectable } from "../router/routes";
import { createLDTHost } from "../../../dt-plugins/sidewindow";
import { defaultConfig } from "@/dt-plugins/sidewindow/config.model";
import { childOfOrEqualDetails, handleFromRoute } from "../../../utility/route";

const LDTConfig = {
  entityName: "venue",
  ldtRoutes: bookingVenueListLDTRoutes,
  detailsSelectableFunction: getBookingVenueDetailsSelectable,
  primaryKey: "venue_id",
  storeNs: storeNS,
  SELECT_ACTION: VenueActionTypes.VenueDetails.FETCH.SINGLE,
  SELECT_AUTO_ACTION: VenueActionTypes.VenueDetails.FETCH.SINGLE,
  listKey : 'venueList'
};

export default {
  components: {
    VenueSidewindow,
    Sidewindow,
    InputField,
    Dropdown,
    NTable,
  },
  data: function () {
    return {
      right: true,
      clipped: false,
      selectedUser: null,

      // searchString: "",
      // searchSubject$: new Subject(),

      venueTableConfig: createNTableConfig({
        fullHeight: true,
        rowHeight: 40,
        scrollNextThreshold: 95,
      }),

      selectedClickedVenue: null,
      defaultConfig: defaultConfig,
    };
  },
  mounted: function () {
    // this[VenueActionTypes.FETCH_BOOKING_VENUES]({});
    // this.fetchList();
    // this.$subscribeTo(
    //   this.searchSubject$
    //     .asObservable()
    //     .pipe(distinctUntilChanged(), debounceTime(350)),
    //   (searchString) => {
    //     this[ArtistActionTypes.SEARCH_VENUES](searchString);
    //   }
    // );
  },
  mixins: [createFetchListMixin(VenueActionTypes.VenueList.FETCH.ALL), createLDTHost(LDTConfig)],
  watch: {
    /*
    $route: {
      immediate: true,
      handler: function (to, from) {
        const { selectResult, venueId } = getVenueDetailsSelectable(to, from);

        switch (selectResult) {
          case SelectResults.SELECT: {
            this.selectVenue(venueId);
            break;
          }
          case SelectResults.SELECT_AUTO: {
            this.selectVenueAuto(venueId);
            break;
          }
          case SelectResults.CLOSE: {
            this.closeVenueDetails();
            break;
          }
          case SelectResults.IGNORE: {
            break;
          }
        }

        // console.log(selectResult, venueId);
      },
    }, */
  },
  computed: {
    ...mapGetters(storeNS, {
      artists: "artists",
      usersTV: "usersTV",
      venues: "venues",
      venueList: "venueList",
      venueStartRow: "venueStartRow",
    }),
    venueDetailsFlag: function () {
      // return childOfOrEqual(bookingVenueRoutes.names.details)(this.$route.name);
      return childOfOrEqualDetails(bookingVenueListLDTRoutes, this.$route);
    },
    list: function () {
      return this.venueList || [];
    },
    filter: function () {
      return {
        ...this.metaFilter,
        basicFilter: this.basicFilter,
        searchFilter: this.searchFilter,
      };
    },
    headers: function () {
      return [
        createTableHeader("locations", { fw: 700 }), //
        createTableHeader("address1"),
        createTableHeader("city"),
        createTableHeader("country"),
        createTableHeader("phone1"),
        createTableHeader("capacity"),
        createTableHeader("url1"),
        createTableHeader("email"),
        createTableHeader("options", { text: false, mw: 40 }),
      ];
    },
    advancedSearchData() {
      return {};
    },
  },
  methods: {
    ...mapActions(storeNS, {
      [VenueActionTypes.FETCH_BOOKING_VENUES]:
        VenueActionTypes.FETCH_BOOKING_VENUES,
      [VenueActionTypes.SEARCH_VENUES]: VenueActionTypes.SEARCH_VENUES,
      [VenueActionTypes.SET_SELECTED_VENUE]:
        VenueActionTypes.SET_SELECTED_VENUE,
      [VenueActionTypes.VenueList.FETCH.ALL]:
        VenueActionTypes.VenueList.FETCH.ALL,
      [VenueActionTypes.VenueList.DELETE.SINGLE]:
        VenueActionTypes.VenueList.DELETE.SINGLE,
      // [ArtistActionTypes.SET_ARTIST_DETAILS]: ArtistActionTypes.SET_ARTIST_DETAILS,
      // [ArtistActionTypes.SEARCH_ARTIST]: ArtistActionTypes.SEARCH_ARTIST,
      // [ArtistActionTypes.FILTER_ARTIST_BY_USER]: ArtistActionTypes.FILTER_ARTIST_BY_USER,
      // [ArtistActionTypes.DELETE_ARTIST]: ArtistActionTypes.DELETE_ARTIST
    }),
    fetchAdvancedSearchData() {},
    defaultBasicFilter() {
      return {
        searchString: "",
      };
    },
    // fetchList: function (addStartRow = 0) {
    //   this[VenueActionTypes.FETCH_BOOKING_VENUES]({
    //     startRow: this.venueStartRow + addStartRow,
    //   });
    // },
    onRowClicked: function (venue) {
      this.selectedClickedVenue = venue;
      this.$router.push({
        name: bookingVenueRoutes.names.tab,
        params: {
          venue_id: venue.booking_location_id,
          tab: this.$route.params.tab ? this.$route.params.tab : "overview",
        },
      });
    },
    onMail: function (artist) {},
    deleteVenue: async function (venue) {
      const { booking_location_id, booking_location_name } = venue;
      console.log({ venue: venue });

      const { has_bookingevent_relation } =
        await VenueService.checkCalendarDateRelation({
          booking_location_id,
        });

      if (has_bookingevent_relation == "yes") {
        const confirmationResult = await ConfirmationService.createP({
          body: "This Location can not be removed. It is related to a booking.",
          width: 376,
          results: [
            createConfirmResult({
              value: "ok",
              text: "OK",
              classes: ["v1 s7"],
            }),
          ],
        });
        // ConfirmationService.create({
        //   subject: `This Location can not be removed. It is related to a booking.`,

        //   width: 376,
        //   results: [
        //     {
        //       text: "OK",
        //       value: "OK",
        //       classes: ["v1 s7"],
        //     },
        //   ],
        //   completed: (res) => {
        //     switch (res) {
        //       case "OK": {
        //         console.log({ value: "OK" });
        //         break;
        //       }
        //     }
        //   },
        // });
      } else {
        try {
          const confirmationResult = await confirmDelete(
            "Venue",
            booking_location_name
          );
          if (confirmationResult == "OK") {
            this[VenueActionTypes.VenueList.DELETE.SINGLE]({
              booking_location_id,
            });
          }
        } catch (error) {}
      }

      console.log({ has_bookingevent_relation: has_bookingevent_relation });

      // ConfirmationService.create({
      //   subject: `Do you really want to delete the artist "${artist.artist_name}" ?`,
      //   model: true,
      //   width: 500,
      //   completed: res => {
      //     switch(res) {
      //       case 'OK': {
      //         this[ArtistActionTypes.DELETE_ARTIST]({
      //           artistId: artist.artist_id
      //         });
      //         break;
      //       }
      //     }
      //   }
      // });
    },
    onCloseVenueSidewindow: function () {
      this.selectedClickedVenue = null;
      this.closeVenueDetails();
      // if (this.$route.query && this.$route.query.from) {
      //   this.$router.push({
      //     ...decode(this.$route.query.from),
      //   });
      // } else {
      //   this.$router.push({
      //     name: bookingVenueRoutes.names.list,
      //   });
      // }
      
      handleFromRoute(this, () => {
        this.$router.push({
          name: bookingVenueListLDTRoutes.names.list,
        });
      });
    },
    selectVenue: function (venueId) {
      const selectedVenue = this.venues.find(
        (venue) => venue.booking_location_id === venueId
      );
      this[VenueActionTypes.SET_SELECTED_VENUE]({
        flag: true,
        location: selectedVenue,
        bookingLocationId: venueId,
      });
    },
    selectVenueAuto: function (venueId) {
      this[VenueActionTypes.SET_SELECTED_VENUE]({
        flag: true,
        location: {
          booking_location_id: venueId,
        },
        bookingLocationId: venueId,
      });
    },
    closeVenueDetails: function () {
      this[VenueActionTypes.SET_SELECTED_VENUE]({
        flag: false,
      });
    },
    // onSearchInputKeyup: function (event) {
    //   this.selectedUser = null;
    //   this.searchString = event.target.value;
    //   this.searchSubject$.next(this.searchString);
    // },
    onUserSelected: function (value) {
      this.searchString = "";
      this.selectedUser = value;

      // this[ArtistActionTypes.FILTER_ARTIST_BY_USER]({
      //   userId: this.selectedUser && this.selectedUser.value
      // });
    },
    onAddVenueClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "add_venue",
        },
      });
    },
    selectedRow: function (venue) {
      return (
        this.selectedClickedVenue &&
        this.selectedClickedVenue["booking_location_id"] ===
          venue["booking_location_id"]
      );
    },

    //MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-booking-venues-venue_list {
  .dt-ntable.venue-list {
    --ntable-height: calc(100vh - 135px);

    @media (min-width: 320px) and (max-width: 480px) {
      th:nth-child(2),
      td:nth-child(2),
      th:nth-child(3),
      td:nth-child(3),
      th:nth-child(4),
      td:nth-child(4),
      th:nth-child(7),
      td:nth-child(7) {
        display: none;
      }
    }

    /* td {
      line-height: 8px;

      &.options {
        .option-buttons {
          display: flex;
          justify-content: space-between;
        }
      }
    } */
  }

  .venues-top-bar {
    margin-bottom: 10px;
    display: flex;
    flex-direction: row;

    & > div {
      margin: 0px 10px;
    }

    .add-button {
      flex: 0.015;
      display: flex;
    }
    .search {
      flex: 2;
    }
    .right-space {
      flex: 8;
    }

    @media screen and (min-width: 320px) and (max-width: 480px) {
      .search {
        flex: 4;
      }
      .right-space {
        flex: 0.1;
      }
    }

    .dropdown {
      flex: 5;
      max-width: 127px;
      margin: 0px 10px;

      // /deep/ .dropdown--main {
      //   border-bottom: 1px solid var(--sprt-5);
      // }
    }
  }
}
</style>
